import { render } from "./paypalConfigDetails.vue?vue&type=template&id=378b3e39&ts=true"
import script from "./paypalConfigDetails.vue?vue&type=script&lang=ts"
export * from "./paypalConfigDetails.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__